module.exports = __webpack_public_path__ + "static/media/CTLI_11-111w.39b12e5d.webp";